import React from 'react';

interface StrategyExchangeInfoProps {
  /** When false, only KuCoin is shown (no Sagemaster label or copy). */
  sagemasterEnabled: boolean;
  /** badges = pill tags (admin/retail modals); inline = single line (Full Analytics). */
  variant?: 'badges' | 'inline';
  style?: React.CSSProperties;
}

/**
 * Exchange attribution for strategy analytics modals.
 * Hides all Sagemaster references when the provider is disabled in admin config.
 */
const StrategyExchangeInfo: React.FC<StrategyExchangeInfoProps> = ({
  sagemasterEnabled,
  variant = 'badges',
  style,
}) => {
  if (variant === 'inline') {
    return (
      <div style={{ fontSize: 14, color: '#212529', ...style }}>
        <span style={{ fontWeight: 500 }}>KUCOIN:</span>{' '}
        {sagemasterEnabled
          ? <>Data source • <span style={{ fontWeight: 500 }}>SAGEMASTER:</span> Trade execution</>
          : <>Data source & trade execution</>}
      </div>
    );
  }

  return (
    <div style={{ fontSize: 14, color: '#666', marginBottom: 12, ...style }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 600 }}>Exchanges:</span>
        <span
          style={{
            display: 'inline-block',
            padding: '2px 8px',
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
            borderRadius: 4,
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          KUCOIN
        </span>
        {sagemasterEnabled && (
          <>
            <span style={{ color: '#999' }}>+</span>
            <span
              style={{
                display: 'inline-block',
                padding: '2px 8px',
                backgroundColor: '#f3e5f5',
                color: '#7b1fa2',
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              SAGEMASTER
            </span>
          </>
        )}
      </div>
      <div style={{ fontSize: 12, color: '#888', fontStyle: 'italic', wordBreak: 'break-word' }}>
        {sagemasterEnabled
          ? 'KUCOIN: Data source • SAGEMASTER: Trade execution'
          : 'KUCOIN: Data source & trade execution'}
      </div>
    </div>
  );
};

export default StrategyExchangeInfo;
